export default {
  "Please read the Terms & Conditions and Privacy Statement before checking the button.":
    "Please read the Terms & Conditions and Privacy Statement before checking the button.", // 协议没选
  "It's working too fast. Please try again in 10 seconds.":
    "It's working too fast. Please try again in 10 seconds.", // 10秒后才能二次验证
  "Invitation code": "លេខរៀងអញ្ជើញ", // 1003
  "Invitation code error": "លេខរៀងអញ្ជើញមិនត្រូវត្រូវ", // 失败提示用于else
  // 注册页开始
  Name: "ឈ្មោះ៖",
  Age: "អាយុ",
  "Please do not register if you are under 18 years old":
    "សូមកុំចុះឈ្មោះ ប្រសិនបើអ្នកមានអាយុក្រោម 18 ឆ្នាំ។",
  Gender: "ភេទ",
  Male: "ប្រុស",
  Female: "ស្រី",
  Other: "ផ្សេងៗ",
  Email: "Email",
  "Phone number of emergency contact person": "លេខទូរសព្ទ័ទំនាក់ទំនង",
  "Please share your professional experience": "សូមចែករំលែកបទពិសោធន៍របស់អ្នក",
  "Previous race certificate within 3 years":
    "វិញ្ញាបនបត្រប្រណាំងពីមុនក្នុងរយៈពេល 3 ឆ្នាំ",
  "Your information is incorrect": "ព័ត៌មានរបស់អ្នកមិនត្រឹមត្រូវទេ",
  "Your registration is successful. Please check more race information on your personal center.":
    "ការចុះឈ្មោះរបស់អ្នកបានជោគជ័យ។ សូមពិនិត្យមើលព័ត៌មានបន្ថែមនៅលើមជ្ឈមណ្ឌលផ្ទាល់ខ្លួនរបស់អ្នក។",
  "Your registration has been successfully submitted and is currently under review. Since this is a professional race, your qualification needs to undergo evaluation. Please check the status on your personal center.":
    "ការចុះឈ្មោះរបស់អ្នកត្រូវបានបញ្ជូនដោយជោគជ័យ ហើយបច្ចុប្បន្នកំពុងស្ថិតក្រោមការត្រួតពិនិត្យ។ ដោយសារនេះគឺជាការប្រណាំងដែលមានជំនាញវិជ្ជាជីវៈ គុណវុឌ្ឍិរបស់អ្នកត្រូវឆ្លងកាត់ការវាយតម្លៃ។ សូមពិនិត្យមើលព័ត៌មាននៅលើមជ្ឈមណ្ឌលផ្ទាល់ខ្លួនរបស់អ្នក។",
  // 注册页结束
  // 报名成功开始
  Pending: "Pending",
  "Congratulations!": "សូមអបអរសាទរ",
  // 报名成功结束
  advertisement: {
    title: "Xiaomi Smart Band 9",
    desc: "Xiaomi Smart Band 9 Introduction",
  },
  common: {
    "Personal page": "ព័ត៌មាន​ផ្ទាល់ខ្លួន",
    "Sign out": "ចាកចេញ",
    "Sign in": "ចូល",
    professionalRace: "រត់ប្រវែង 5គីឡូម៉ែត្រ",
    runForFun: "រត់ដើម្បីសុខភាពនិងភាពរីករាយ",
    introduction: "ការណែនាំ​Xiaomi POP Run 2024",
    termsAndCondition: "លក្ខខណ្ឌ",
    privacyStatement: "Privacy Statement",
    title: "Xiaomi POP Run 2024",
    mile: "10km",
    mile2: "",
    btn: {
      confirm: "យល់ព្រម",
    },
  },
  home: {
    btn: {
      runNow: "Run Now",
    },
  },
  register: {
    disclaimer:
      "មុនពេលចូលរួមក្នុងការរត់ប្រណាំង សូមធ្វើការវាយតម្លៃដ៏ទូលំទូលាយអំពីសុខុមាលភាពរាងកាយរបស់អ្នក ដើម្បីបញ្ជាក់ថាអ្នកបំពេញតាមស្តង់ដារដែលត្រូវការ។",
    submit: "ដាក់ស្នើ",
  },
  details: {
    area: {
      p: "Professional Race Running time:",
      runTime: "Run for Fun Running time:",
    },
    card: {
      countdownToRegistrationStarts: "រាប់ថយក្រោយដើម្បីចុះឈ្មោះ",
      countdownToRegistrationEnds: "ការចុះឈ្មោះបានត្រូវបញ្ចប់",
      Days: "ថ្ងៃ",
      Hours: "ម៉ោង",
      Minutes: "នាទី",
    },
    btn: {
      register: "ចុះឈ្មោះ",
      runNow: "Run Now",
      enrollmentIsFull: "ការចុះឈ្មោះបានពេញ",
      registrationIsClosed: "ការចុះឈ្មោះបានបិទ",
    },
    desc: {
      invitationCodeRegistration:
        "រយៈពេលបច្ចុប្បន្នគឺសម្រាប់ការចុះឈ្មោះលេខកូដអញ្ជើញ",
    },
  },
  review: {
    title: "អ្នកមិនអាចផ្លាស់ប្តូរប្រតិបត្តិការបានទេ នៅពេលដែលវាត្រូវបានបញ្ជាក់។",
    more: "ច្រើនទៀត",
    text: "បិទការរំលឹក",
    btn: {
      agree: "យល់ព្រម",
      disagree: "មិនយល់ព្រម",
    },
  },
  end: {
    logout: "Log out",
    infoHeader: {
      title: "POP Run 2024",
      runTime: "Running Time：",
      btn: {
        runNow: "Run Now",
        pending: "កំពុងរង់ចាំ",
        registered: "បានចុះឈ្មោះ",
        rejected: "Application failed",
        waiting: "រង់ចាំការបញ្ជាក់ជាផ្លូវការ",
        unfortunately: "ជាអកុសលកម្មវិធីរបស់អ្នកត្រូវបានបដិសេធ",
      },
    },
    application: "ពាក្យសុំចុះឈ្មោះ",
    checkMore: {
      about: "ស្វែងយល់បន្ថែមនៅទីនេះ៖",
    },
    participationHistory: {
      header: "ប្រវត្តិនៃការចូលរួម",
      noHistory: "No history",
      h2: "Xiaomi Pop Run { year }-Professional Race",
    },
    share: {
      name: "ឈ្មោះ៖",
      country: "ប្រទេស៖",
      download: "ទាញយក",
      shareOn: "ចែករំលែក៖",
      content:
        "ជាមួយ #XiaomiPOPRun2024 អញ្ជើញមនុស្សឱ្យចូលរួមការប្រណាំងកាន់តែច្រើន!",
      description:
        "Invite more friends to join the race and feel passion beyond limits!",
    },
  },
  footer: {
    copyright: "Copyright©2016-{year} Xiaomi.com, All Rights Reserved",
  },
  dialog: {
    logOut: {
      content: "Please check if you want to log out",
      confirm: "យល់ព្រម",
      cancle: "Cancle",
    },
    countrySelect: {
      headerTitle: "Country",
      headerContent:
        "Country-City name The following list displays the hosting cities for the Xiaomi POP Run 2024",
      rowNow: "Run Now",
      footerContent:
        "*For some countries, the registration will be redirected to an external website",
    },
  },
};
